// extracted by mini-css-extract-plugin
module.exports = {"headline":"ExtendedReturnsPolicy_headline__8gds5"};